import script from "./FormCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./FormCheckbox.vue?vue&type=style&index=0&id=7d146831&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d146831"]])

export default __exports__